<div class="row">
	<div class="col-sm-12">
		{{#if link}}<a class="m-r-10" href="{{link}}"><i class="fa fa-bar-chart-o" title="{{TR "In Analyse zeigen"}}"></i></a>{{/if}}
		{{TR name}}
		{{#if info}}<a class="m-l-5" data-toggle="collapse" data-parent="#id-{{id}}" href="#id-details-{{id}}"><i class="fa fa-info-circle"></i></a>{{/if}}
	</div>
	{{#if info}}
	<div id="id-details-{{id}}" class="col-sm-12 collapse m-t-15">
		<div class="row">
			<div class="col-sm-12">
				{{{info}}}
			</div>
		</div>
	</div>
	{{/if}}
</div>
